import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mav-light-theme',
  template: '',
  styleUrls: ['./light-theme.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LightThemeComponent {
  constructor() { }
}
